import React from 'react'

function ApprovedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <path
        fill="#009767"
        d="M13 0a13 13 0 1 0 0 26 13 13 0 0 0 0-26Zm5.59 9.893-5.941 7.8a1.3 1.3 0 0 1-1.597.378 1.3 1.3 0 0 1-.457-.365l-3.172-4.043a1.302 1.302 0 0 1 2.054-1.599l2.119 2.704 4.914-6.5a1.308 1.308 0 0 1 2.08 1.586v.039Z"
      />
    </svg>
  )
}
export default ApprovedIcon
